<div class="relative">
  <textarea type="text"
            #inputElement
            [(ngModel)]="value"
            class="block px-2.5 py-2.5 w-full disabled:text-fg-disabled text-base text-gray-900 bg-transparent rounded-lg border-1 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-brand focus:outline-none focus:ring-0 focus:border-brand peer"
            [id]="id()"
            [name]="name()"
            [placeholder]="placeholder()"
            [disabled]="disabled()"
            [required]="required()"
            [attr.maxlength]="maxlength()"
            [attr.minlength]="minlength()"
            [autocomplete]="autocomplete()"
            [rows]="rows()"
            [cols]="cols()"
            [style.resize]="resize()"
  ></textarea>
  <label [for]="id()"
         class="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] {{labelBackground()}} px-2 peer-focus:px-2 peer-focus:text-brand peer-focus:dark:text-brand peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-6 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">
    <ng-content select="[icon]"></ng-content> {{label()}}@if (required() && label()) {<span class="font-semibold text-danger">*</span>}
  </label>

  @if (maxlength()) {
    <span class="absolute text-xs text-gray-500 dark:text-gray-400 duration-300 transform scale-75 z-10 origin-[0] right-0 bottom-1">
      {{value().toString().length}}/{{maxlength()}}
    </span>
  }
</div>

@if (help()) {
  <p class="text-xs text-body px-2">{{help()}}</p>
}
